__turbopack_context__.v({
  "checkbox": "toggle-module-scss-module__5Vwu4W__checkbox",
  "checkboxButton": "toggle-module-scss-module__5Vwu4W__checkboxButton",
  "checkboxButton_input": "toggle-module-scss-module__5Vwu4W__checkboxButton_input",
  "checkboxButton_label": "toggle-module-scss-module__5Vwu4W__checkboxButton_label",
  "radio": "toggle-module-scss-module__5Vwu4W__radio",
  "switch": "toggle-module-scss-module__5Vwu4W__switch",
  "toggleInput": "toggle-module-scss-module__5Vwu4W__toggleInput",
  "toggleInput__left": "toggle-module-scss-module__5Vwu4W__toggleInput__left",
  "toggleInput_child": "toggle-module-scss-module__5Vwu4W__toggleInput_child",
});
